import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

/**
 * Interceptor para optimizar la descarga de imágenes
 * - Añade headers de cache para imágenes estáticas
 * - Mantiene conexiones persistentes (keep-alive)
 * - Mejora rendimiento en Kubernetes y Docker
 */
export const httpCacheInterceptor: HttpInterceptorFn = (req, next) => {
    // Obtener el host del servidor de imágenes desde la configuración
    const imgServerHost = environment.SERVER_IMG;

    // Detectar si es una petición de imagen
    const isImageRequest = req.url.includes('/gemmasales/') ||
        req.url.includes('gsales-img') ||
        (imgServerHost && req.url.includes(imgServerHost));

    // Solo aplicar optimizaciones a imágenes estáticas
    if (isImageRequest) {
        const modifiedReq = req.clone({
            setHeaders: {
                'Cache-Control': 'public, max-age=604800',  // 7 días
                'Connection': 'keep-alive'
            }
        });

        return next(modifiedReq);
    }

    // Peticiones normales sin modificar
    return next(req);
};
